import { AttachmentsList } from '../../components/AttachmentsList';
import type { AttachmentResource } from '../attachments/types';

interface EmergencyAttachmentsModalProps {
  open: boolean;
  onClose: () => void;
  resourceType: Extract<AttachmentResource, 'emergency_plan' | 'emergency_drill'>;
  resourceId: string;
  title: string;
  readOnly?: boolean;
}

export function EmergencyAttachmentsModal({
  open,
  onClose,
  resourceType,
  resourceId,
  title,
  readOnly = false,
}: EmergencyAttachmentsModalProps) {
  if (!open) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40 p-4">
      <div className="w-full max-w-3xl rounded-lg bg-card p-6 shadow-lg border border-border max-h-[90vh] overflow-y-auto">
        <div className="flex items-center justify-between gap-4 mb-4">
          <h2 className="text-lg font-semibold">{title}</h2>
          <button type="button" className="btn btn-outline btn-sm" onClick={onClose}>
            Cerrar
          </button>
        </div>
        <AttachmentsList
          resourceType={resourceType}
          resourceId={resourceId}
          readOnly={readOnly}
          title="Evidencias adjuntas"
        />
      </div>
    </div>
  );
}
